import { Injectable } from '@angular/core'

import { EnvironmentService } from 'app/environment.service'
import { AuthHttpService } from 'app/shared/auth-http.service'
import { ILoyaltyCardDeleteResult } from 'app/passengers/passengers.interfaces'
import { Observable } from 'rxjs'


@Injectable()
export class LoyaltyNectarService {

    constructor(
        private authHttp: AuthHttpService,
        private environmentService: EnvironmentService,
    ) { }

    removeCardFromUserProfile(provider: number): Observable<ILoyaltyCardDeleteResult> {
        const url = `${this.environmentService.getOrchestrationUrl()}/loyalty/${provider}`
        return this.authHttp.delete<ILoyaltyCardDeleteResult>(url)
    }

    // // 00012369019
    // getValidateValidator(provider: string, preCardNumber: string): AsyncValidatorFn {
    //     return (c: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
    //         return new Promise((res, rej) => {
    //             if (!c.value) {
    //                 return res(null)
    //             }
    //             const search: URLSearchParams = new URLSearchParams()
    //             search.set('provider', provider)
    //             search.set('cardNumber', `${preCardNumber}${c.value}`)
    //             const url = `${this.environmentService.getOrchestrationUrl()}/loyalty-valid`
    //             this.authHttp.get(url, { search }).map(d => d.json() as IValidationResult).subscribe(x => res(x.valid ? null : { checkCardNumber: true }))
    //         })
    //     }
    // }
}
